module.exports = __webpack_public_path__ + "img/pic17.8e9ae5ea.png";